export const MARITALTAX_LOADING = "MARITALTAX_LOADING";
export const MARITALTAX_RESET = "MARITALTAX_RESET";
export const GET_MARITALTAX = "GET_MARITALTAX";
export const GET_MARITALTAX_SUCCESS = "GET_MARITALTAX_SUCCESS";
export const GET_MARITALTAX_FAIL = "GET_MARITALTAX_FAIL";
export const DELETE_MARITALTAX = "DELETE_MARITALTAX"
export const DELETE_MARITALTAX_SUCCESS = "DELETE_MARITALTAX_SUCCESS"
export const DELETE_MARITALTAX_FAIL = "DELETE_MARITALTAX_FAIL"
export const UPDATE_MARITALTAX = "UPDATE_MARITALTAX"
export const UPDATE_MARITALTAX_SUCCESS = "UPDATE_MARITALTAX_SUCCESS"
export const UPDATE_MARITALTAX_FAIL = "UPDATE_MARITALTAX_FAIL"
export const ADD_NEW_MARITALTAX = "ADD_NEW_MARITALTAX"
export const ADD_MARITALTAX_SUCCESS = "ADD_MARITALTAX_SUCCESS"
export const ADD_MARITALTAX_FAIL = "ADD_MARITALTAX_FAIL"